import { render, staticRenderFns } from "./PermissionField.vue?vue&type=template&id=b4382ac0"
import script from "./PermissionField.vue?vue&type=script&lang=js"
export * from "./PermissionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports